module.exports = __webpack_public_path__ + "static/media/Tanzania.b48d1a0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/Tanzania.jpg
// module id = 991
// module chunks = 0